"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _path;
var Error = function Error(props) {
  return /*#__PURE__*/_react.default.createElement("svg", Object.assign({
    viewBox: "0 0 96 96"
  }, props), _path || (_path = /*#__PURE__*/_react.default.createElement("path", {
    d: "M49.691 12.677l44.371 70.255A2 2 0 0 1 92.372 86H3.628a2 2 0 0 1-1.691-3.068l44.371-70.255a2 2 0 0 1 3.382 0zm-3.382 13.11L14.638 75.931A2 2 0 0 0 16.328 79h63.343a2 2 0 0 0 1.691-3.068L49.691 25.786a2 2 0 0 0-3.382 0zM47 42h3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2V44a2 2 0 0 1 2-2zm0 22h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2z",
    fill: "currentColor"
  })));
};
var _default = exports.default = Error;